module.exports = __webpack_public_path__ + "img/exemplo-icones-coberturas.3dce849c.png";